/**
 * Sets overflow on html and body to stop page scrolling while an overlay is open
 * @param {boolean} disable
 */
export default function togglePageScroll(disable = false) {

    if (disable) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.maxHeight = '100vh';
        return;
    }

    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
    document.documentElement.style.maxHeight = 'none';

}
